import React from "react";
import Navbar from "../components/navbar/navbar";
import Project from "../components/project/project";
import Footer from "../components/footer/footer";

const BeCharge: React.FC = () => {


  return (
    <>
      <Navbar/>
      <div className="page-content">
        <Project project="becharge"/>
      </div>
      <Footer />
    </>
  );
};

export default BeCharge;